module.exports = __webpack_public_path__ + "img/source_book-item12.e85b8e0f.png";